/**
 * getServiceBatches
 *
 * @description
 * Splits service names into deterministic batches to control concurrent list
 * requests.
 * @template T
 * @param {T[]} serviceNames - Ordered service names to group.
 * @param {number} batchSize - Maximum items per batch.
 * @returns {T[][]}
 *
 */
const getServiceBatches = (serviceNames, batchSize) => serviceNames.reduce((acc, serviceName, index) => {
    const batchIndex = Math.floor(index / batchSize);
    if (!acc[batchIndex]) {
        acc[batchIndex] = [];
    }
    acc[batchIndex].push(serviceName);
    return acc;
}, []);
export default getServiceBatches;
